// extracted by mini-css-extract-plugin
module.exports = {"root":"PillCard_root__XZsjm","pillTitle":"PillCard_pillTitle__VL8L2","vimeoPreview":"PillCard_vimeoPreview__1pCln","pillDuration":"PillCard_pillDuration__2__k7"};